<template>
  <div>
    <div class="container">
        <v-form ref="form" lazy-validation>
          <form-config
            ref="config"
            :formulario="formulario"
            tabela="apontamentoproducao"
          />
            <div class="d-flex justify-center contaainer">
              <v-text-field ref="balanca"
              outlined label="Numero Balança" class="textfield n-center"
              background-color="white" type="number"
              :rules="rules.appnumerobalanca"
              v-model="formulario.appnumerobalanca"         
              @keydown="$_limitaBalanca"
              @keyup.enter="$refs.balanca.blur(); $refs.lote.$children[0].focus();"></v-text-field>
              <v-autocomplete v-if="$$_usaSafra" ref="safra"
              label="Safra"
              :items="$$_safrasAutocomplete"
              outlined
              class="textfield n-center"
              background-color="white" 
              v-model="safra">
              </v-autocomplete>
              <div class="linha-qr">
                <card-auto-complete ref="lote"
                  label="Lote P.A."
                  :class="['textfield', 'n-center', { 'campo-bloqueado': loteviaqr }]"
                  :dados="$$_lotesSafra"
                  :readonly="loteviaqr"
                  v-model="formulario.appidaberturalote"
                  itemLabel="ablnrocontrole"  
                  item-value="ablidaberturalote"
                  :return-object="false"
                  :rules="rules.ablidaberturalote"
                  hide-details
                  icon="mdi-qrcode-scan"
                  :action="$_onClickQR"
                  @focus="$_scrollUp($event)"
                  @keyup.enter="$refs.lote.$children[0].blur(); $refs.peso.focus()"
                />
                  <v-text-field
                  outlined
                  :background-color="loteviaqr ? '#fdffd2' : 'white'"
                  :readonly="loteviaqr"
                  type="number"
                  label="Bag"
                  class="numero-armazenamento n-center"
                  v-model="formulario.appnumerobag"
                  maxlength="2"
                  @keydown="$_limitaBag"
                  hide-details>
                  </v-text-field>
              </div>
              <!-- <v-text-field outlined label="Data/Hora" class="textfield n-center" readonly
              v-model="formulario.appdatapesagem"></v-text-field> -->
            <v-card class="descricaoextra" v-if="lotecompleto?.abldescricao">
              <b class="centerextra" style="font-weight: 600;">{{lotecompleto?.abldescricao}}</b>
              <v-divider></v-divider>
              <b class="centerextra" style="font-weight: 600;">{{lotecompleto?.ablgranulometria}}</b>
              <v-divider></v-divider>
              <b class="centerextra" style="font-weight: 600;">{{variedadeCompleta?.vardescricao}}</b>
              <v-divider v-if="apontamentoCompleto?.apppeso"></v-divider>
              <b class="centerextra" style="font-weight: 600;">{{apontamentoCompleto?.apppeso}}</b>
            </v-card>
            <v-text-field ref="peso"
            outlined label="Peso" class="textfield n-center" type="number"
            background-color="white" :rules="rules.apppeso"
            v-model="formulario.apppeso"
            @keyup.enter="$refs.peso.blur(); $refs.local.focus()"></v-text-field>
            <v-autocomplete ref="local"
            :items="locaisdaop"
            :readonly="!locaisdaop"
            item-text="loadescricao"
            item-value="loaidlocalarmazenamento"
            outlined label="Local" 
            class="textfield n-center"
            background-color="white" 
            :rules="rules.appidlocalmovimentacaoestoque"
            v-model="formulario.appidlocalmovimentacaoestoque"
            @keyup.enter="$refs.local.blur(); $_submit"></v-autocomplete>
            <v-autocomplete ref="local"
            :items="turnosdaop"
            :readonly="!turnosdaop"
            item-text="tupidturno"
            item-value="tupidturno"
            outlined label="Turno" 
            class="textfield n-center"
            background-color="white" 
            :rules="rules.appidturno"
            v-model="formulario.appidturno"
            @keyup.enter="$refs.local.blur(); $_submit"></v-autocomplete>
            <v-autocomplete ref="fabrica"
            label="Fabrica" 
            :items="fabricasdaop"
            :readonly="!fabricasdaop"
            item-text="fabdescricao"
            item-value="fabidfabrica"
            outlined
            class="textfield n-center"
            background-color="white" 
            :rules="rules.appidfabrica"
            v-model="formulario.appidfabrica"
            @keyup.enter="$refs.local.blur(); $_submit"></v-autocomplete>
            <!-- <v-dialog v-model="dialogloterepetido" persistent v-if="existeapontamento">
              <v-card>
                <v-card-title class="text-h6 primary white--text">
                  Lançamento Repetido
                </v-card-title>
                <br/>
                <v-card-text>
                  Já existe um apontamento para o lote selecionado. Escreva uma observação.
                </v-card-text>
                <v-text-field 
                v-model="formulario.appobsduplicado"
                outlined 
                dense 
                label="Observação" 
                :rules="rules.appobsduplicado"
                class="mx-5">
                </v-text-field>
                <v-divider>
                </v-divider>
                <v-card-actions class="d-flex justify-space-between">
                  <v-btn @click="dialogloterepetido = false">
                    Cancelar
                  </v-btn>
                  <v-btn color="primary" @click="$_submit">
                    Enviar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog> -->
            <div class="linha-botoes">
              <v-btn class="botao-acao" @click="$_cancelar" :disabled="enviando">
                Cancelar
              </v-btn>
              <v-btn color="primary" class="botao-acao salvar" @click="$_verificaDuplicado">
                <div v-if="!enviando">Salvar</div>
                <v-progress-circular v-else
                  indeterminate
                  color="white"
                ></v-progress-circular>
              </v-btn>
            </div>

            </div>
        </v-form>
      <!-- <v-text-field></v-text-field> -->
      <br/>
    </div>
  </div>
</template>

<script>

// import errorHandler from '@/utils/error-handler';


import { ROUTE_PRODUCAO_CADASTRO, ROUTE_LOTES_FINALIZADOS, ROUTE_QR, ROUTE_PRODUCAO_C  } from '@/constants/ROUTES';

import FormConfig from '@/components/form/components/form-config/Index.vue';
import CardAutoComplete from '@/components/core/card-auto-complete/Index.vue'

import { OPLOCAL_STORAGE } from '@/constants/STORAGE'

import geraData from '@/utils/geradata'

import $_scrollUp from '@/utils/scroll-up'


// import { OPLOCAL_STORAGE, CADPRODUCAO_STORAGE } from '@/constants/STORAGE';

import db from '@/plugins/dexie';

import moment from 'moment-timezone';

function getSessionStorage(key, defaultValue) {
  return sessionStorage.getItem(key) ?? defaultValue;
}


// import AppCardAtividadeSkeleton from '../../components/app/card/atividade/Skeleton.vue';
import errorHandler from '@/utils/error-handler';
import { SetupEnvioLocal } from '@/utils/atualizalocal';
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
  name: 'ViewLoteC',

  components: {
    FormConfig,
    CardAutoComplete,
  },

  data() {
    return {
      rotaFiltros: [
        ROUTE_PRODUCAO_CADASTRO,
      ],

      fabrica: null,
      loading: true,
      lotes: null,

      lotesdaop: null,
      locaisdaop: null,
      turnosdaop: null,
      fabricasdaop: null,
  
      lotesfechados: null,
      proximolote: null,
      proximoembalagem: null,
      idordemproducao: null,

      formulario: {
        appnumerobalanca: null,
        apppeso: null,
        appidaberturalote: null,
        appidlocalmovimentacaoestoque: null,
        appnumerobag: null,
        appdatapesagem: null,
        appdataalteracao: null,
        appidturno: null,
        appdatanuvem: null,
        appidusuario: null,
        appidnuvem: null,
        appidfabrica: null,
      },
      lotecompleto: null,
      apontamentoCompleto: null,
      variedadeCompleta: null,

      rules: {
        appnumerobalanca: [ v => !!v || 'Numero Balança é obrigatório' ],
        apppeso: [ v => !!v || 'Peso é obrigatório' ],
        appidlocalmovimentacaoestoque: [ v => !!v || 'Local é obrigatório' ],
        ablidaberturalote: [ v => !!v  || 'Lote é obrigatório', !this.jaexiste || 'Já existe um lançamento com esse numero de lote e bag'],
        appnumerobag: [!this.jaexiste || 'Já existe um lançamento com esse numero de lote e bag'],
        appobsduplicado: [ v => !!v || 'Observação é obrigatória'],
        appidturno: [ v => !!v || 'Turno é obrigatório'],
        appidfabrica: [ v => !!v || 'Fabrica é obrigatória'],
      },

      // ESSA VIEW ESTÁ COM VARIAS FUNÇÕES A MAIS, RETIRAR DEPOIS
      

      itensComEsseNro: null,

      lotesMaisRecentes: [],

      dialogloterepetido: false,

      // existeapontamento: false,

      enviando: false,

      idempresa: null,

      jaexiste: true,

      // TRUE QUANDO O LOTE FOI ENCONTRADO PELA LEITURA DO QR CODE
      loteviaqr: false,

      safra: null,
      // SAFRA VINDA DO PARAMETRO DA EMPRESA (TABELA LOCAL empresa)
      empresaSafra: null,
    };
  },

  methods: {
    ...mapMutations({
      $_adicionarCache: 'cache/SET_CACHE',
    }),
 
    ...mapActions({
      $_getCache: 'cache/getCache',
      $_reloadCache: 'cache/reloadCache',
    }),
    
    async  $_scrollUp(e) {
        $_scrollUp(e);
    },

    // A SAFRA DO LOTE SÃO OS 2 ULTIMOS DIGITOS DO NRO DE CONTROLE (EX.: LEC0007/25 -> 2025)
    $_safraDoLote(lote) {
      const nro = lote?.ablnrocontrole;
      return nro ? `20${nro.slice(-2)}` : null;
    },

    async $_setup() {
      this.idempresa = sessionStorage.getItem('idempresa');
      if (this.idempresa !== 'a97bdbfc-8ede-4e1a-832f-54521a20c3d8') {
        this.formulario.appnumerobalanca = 1;
      }
      this.formulario.appdatapesagem = new Date();
      this.formulario.appdatapesagem.setHours(this.formulario.appdatapesagem.getHours() - 3);

      // LIDO ANTES DOS LOTES PARA O INPUT DE SAFRA JÁ NASCER NO ESTADO CERTO.
      // NEM TODA EMPRESA TEM empsafra: VAZIO/ESPAÇOS CONTA COMO SEM PARAMETRO.
      const [emp] = (await (db.empresa?.toArray().catch(() => []) ?? [])) ?? [];
      this.empresaSafra = String(emp?.empsafra ?? '').trim() || null;

      const ablcache = await this.$_getCache('aberturalote');
      const lmecache = await this.$_getCache('localarmazenamento');
      const turcache = await this.$_getCache('turno');
      const fabcache = await this.$_getCache('fabrica');

      if (!ablcache) {
        console.log('aberturalote cached');
        this.lotesdaop = await db.aberturalote.orderBy('ablnrocontrole').toArray();
        this.$_adicionarCache({tabela: 'aberturalote', dados: this.lotesdaop});
      } else {
        this.lotesdaop = this.$$_cacheLote;
      }


      // O AGRUPAMENTO POR SAFRA É DERIVADO DE lotesdaop EM $$_safraMap.
      // AQUI SÓ ESCOLHEMOS A SAFRA INICIAL. SEM PARAMETRO NA EMPRESA NÃO HÁ FILTRO:
      // safra FICA null E A LISTA MOSTRA TODOS OS LOTES.
      // SE O LOTE JÁ VEIO DO QR, A SAFRA DELE TEM PRIORIDADE PARA QUE APAREÇA NA LISTA
      this.safra = this.empresaSafra
        ? (this.$_safraDoLote(this.lotecompleto)
          || this.empresaSafra
          || this.$$_safrasAutocomplete.at(-1))
        : null;

      if (!lmecache) {
        console.log('localarmazenamento cached');
        const lotesdb = await db.localarmazenamento.toArray();
        this.locaisdaop = lotesdb.filter((item) => item.loausadoapppesagem === 'S' );
        this.$_adicionarCache({tabela: 'localarmazenamento', dados: this.locaisdaop});
      } else {
        this.locaisdaop = this.$$_cacheLocal;
      }

       if (!turcache) {
        console.log('turno cached');
        this.turnosdaop = await db.turno.toArray();
        this.$_adicionarCache({tabela: 'turno', dados: this.turnosdaop});
       } else {
        this.turnosdaop = this.$$_cacheTurno;
       }

       if (!fabcache) {
        console.log('fabrica cached');
        this.fabricasdaop = await db.fabrica.toArray();
        this.$_adicionarCache({tabela: 'fabrica', dados: this.fabricasdaop });
       } else {
        this.fabricasdaop = this.$$_cacheFabrica;
       }
       

      this.turnosdaop.forEach((turno) => {
          const abertura = '2025' + turno.tupdataabertura.slice(4);
          const fechamento = '2025' + turno.tupdatafechamento.slice(4);

          const timeAbertura = moment.utc(abertura).add(3, 'hours');
          const timeFechamento = moment.utc(fechamento).add(3, 'hours');

          const nowTime = moment.utc();

          const format = 'HH:mm';
          const onlyTimeNow = nowTime.format(format);
          const onlyTimeAbertura = timeAbertura.format(format);
          const onlyTimeFechamento = timeFechamento.format(format);

          const tNow = moment.utc(onlyTimeNow, format);
          const tAbertura = moment.utc(onlyTimeAbertura, format);
          const tFechamento = moment.utc(onlyTimeFechamento, format);

          if (tNow.isSameOrAfter(tAbertura) && tNow.isSameOrBefore(tFechamento)) {
            this.formulario.appidturno = turno.tupidturno;
          }
      })
        this.$refs.peso.focus();
    },

    async $_limitaBalanca(e) {
      if (this.formulario.appnumerobalanca?.length > 2 && e.key !== 'Enter') {
        setTimeout(() => {
          this.formulario.appnumerobalanca= this.formulario.appnumerobalanca.slice(0, -1) //'abcde'
        })
      }
    },

    $_limitaBag(e) {
      const teclasPermitidas = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Enter', 'Home', 'End'];
      if (teclasPermitidas.includes(e.key) || e.ctrlKey || e.metaKey) return;
      if (!/^[0-9]$/.test(e.key)) {
        e.preventDefault();
        return;
      }
      if (String(this.formulario.appnumerobag ?? '').length >= 2) {
        e.preventDefault();
      }
    },

    async $_submit() {
      if (this.enviando) {
        return;
      }
      if(await this.$_verificajaexiste()) {
        return;
      }
      if (this.$refs.form.validate()) {
        try {
          this.enviando = true;
          this.formulario.appdatapesagem = geraData(),
          this.formulario.appdataalteracao = geraData();
          this.formulario.appdatanuvem = null;
          this.formulario.appidnuvem = 'null';
          // this.formulario.appdatapesagem = new Date().toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' }),
          // this.formulario.appdataalteracao = new Date().toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' });
          // const res = await this.$refs.config.$_submit();
          const res = await db.apontamentoproducao.add(this.formulario);
          if(res){
            errorHandler('Enviado com sucesso!');
            //
            SetupEnvioLocal();
            this.$_reloadCache('apontamentoproducao');
            //
            this.dialogloterepetido = false;
            sessionStorage.setItem(OPLOCAL_STORAGE.qr, '');
            this.formulario = {
              appnumerobalanca: null,
              apppeso: null,
              appidaberturalote: null,
              appidlocalmovimentacaoestoque: null,
              appnumerobag: null,
              appdatapesagem: geraData(),
              appdataalteracao: geraData(),
              appidturno: this.formulario.appidturno,
              appdatanuvem: null,
              appidnuvem: null,
              appidfabrica: null,
            }
            if (this.idempresa !== 'a97bdbfc-8ede-4e1a-832f-54521a20c3d8') {
              this.formulario.appnumerobalanca = 1;
            }
            this.lotecompleto = null;
            this.loteviaqr = false;
            this.$refs.form.resetValidation();
            this.enviando = false;
          }
        } catch(e) {
          this.enviando = false;
          console.log(e, 'eeeee');
          if(e.code == 'ERR_NETWORK'){
            errorHandler('Erro de conexão');
          } else {
            errorHandler(e);
          }
        }
      } else {
        errorHandler('Formulario inválido, verifique os dados e envie novamente');
      }
    },

    $_somaPeso(nro) {
      const itensComEsseNro = this.lotes.filter((item) => {
        return item.applote === nro;
      })

      const soma = itensComEsseNro.reduce((acc, cur) => {
        return acc +  Number(cur.appquantidade);
      }, 0);
      return soma;
    },

    $_verificaDuplicado() {
      this.$_submit();
    },

    // LIMPA O FORMULARIO MANTENDO APENAS O NUMERO DA BALANCA
    $_cancelar() {
      if (this.enviando) {
        return;
      }
      sessionStorage.setItem(OPLOCAL_STORAGE.qr, '');
      sessionStorage.removeItem(OPLOCAL_STORAGE.numerobag);
      sessionStorage.removeItem('formulario');

      this.formulario = {
        appnumerobalanca: this.formulario.appnumerobalanca,
        apppeso: null,
        appidaberturalote: null,
        appidlocalmovimentacaoestoque: null,
        appnumerobag: null,
        appdatapesagem: geraData(),
        appdataalteracao: geraData(),
        appidturno: this.formulario.appidturno,
        appdatanuvem: null,
        appidnuvem: null,
        appidfabrica: null,
      };

      this.lotecompleto = null;
      this.variedadeCompleta = null;
      this.apontamentoCompleto = null;
      this.loteviaqr = false;
      this.jaexiste = true;
      this.$refs.form.resetValidation();
    },

    $_normalizaBag(valor) {
      if (valor === null || valor === undefined || valor === '') return null;
      const numero = Number(String(valor).replace(/\s+/g, ''));
      return Number.isNaN(numero) ? String(valor).trim() : numero;
    },

    async $_verificajaexiste() {
        const apontamentosrealizados = await db.apontamentoproducao.toArray();
        const bagAtual = this.$_normalizaBag(this.formulario.appnumerobag);
        this.jaexiste = apontamentosrealizados.find((item) => {
          return (item.appidaberturalote === this.formulario.appidaberturalote &&
          this.$_normalizaBag(item.appnumerobag) === bagAtual)
        })
        if (this.jaexiste) {
          errorHandler('já existe um lançamento com este lote e numero de bag!');
        }
        return this.jaexiste;
    },

    FormataData(date, formato) {
      // return moment(date, 'YYYY-MM-DD').format('DD/MM-HH:MM');
      return moment.tz(date, 'America/Sao_Paulo').local().format(formato);
    },

    proximoInput() {
      this.$refs.loteb.$children[0].focus();
    },

    $_openDetalhe(nro) {
      sessionStorage.setItem(OPLOCAL_STORAGE.nro, nro);
      this.$router.replace({ 
        ...this.$route,
        name: ROUTE_LOTES_FINALIZADOS.name,
      });
    },

    $_onClickQR() {
      if (this.loteviaqr) {
        return;
      }
      sessionStorage.setItem('formulario', JSON.stringify(this.formulario));
      sessionStorage.setItem('rota-anterior', ROUTE_PRODUCAO_C.path);
      setTimeout(() => {
        this.$router.push({
          ...this.$route,
          name: ROUTE_QR.name,
        });
      });
    },

    async $_verificaQR() {
      const qr = await getSessionStorage(OPLOCAL_STORAGE.qr, '');
      const numerobag = await getSessionStorage(OPLOCAL_STORAGE.numerobag, '');
      if (numerobag) {
        this.formulario.appnumerobag = numerobag;
      }
      if (qr && qr.length && qr !== 'null') {
        const lote  = (await db.aberturalote.where({ ablnrocontrole: qr }).toArray());
        if (!lote.length) {
          errorHandler('Lote não encontrado');
          this.formulario.appnumerobag = null;
          return;
        }
        this.lotecompleto = null;
        this.lotecompleto = lote[0];
        this.formulario.appidaberturalote = lote[0].ablidaberturalote;
        this.loteviaqr = true;
        this.$refs.peso.focus();
        if (typeof this.proximolote === 'object') {
          // this.$_adicionaLote(this.proximolote);
        } else {
          errorHandler('Erro ao adicionar novo lote')
        }
      }
      // sessionStorage.setItem(OPLOCAL_STORAGE.qr, '');
      // this.proximolote = JSON.parse(sessionStorage.getItem('lote'));
      // this.proximoembalagem= JSON.parse(sessionStorage.getItem('loteembalagem'));
    },
  },

  created() {
    SetupEnvioLocal();
    const formulario = sessionStorage.getItem('formulario', null);
    let restaurado = Promise.resolve();
      if (formulario) {
        this.formulario = JSON.parse(formulario);
        restaurado = this.$_verificaQR().then(() => {
          sessionStorage.removeItem('formulario');
        });
      }

    setTimeout(() => {
      // O SETUP ESPERA A LEITURA DO QR PARA CONSEGUIR ESCOLHER A SAFRA DO LOTE LIDO.
      // SEM O CATCH UMA FALHA AQUI ABORTA O RESTANTE DO SETUP (LOCAL/TURNO/FABRICA)
      // SILENCIOSAMENTE E A TELA FICA COM TODOS OS CAMPOS BLOQUEADOS.
      restaurado
        .then(() => this.$_setup())
        .catch((e) => {
          console.log(e, 'setup');
          errorHandler('Erro ao carregar os dados da tela');
        });
    }, 0);
  },

  beforeDestroy() {
    sessionStorage.removeItem('qr');
  },

  computed: {
    ...mapState({
      $$_cacheLote: (state) => state.cache.cache_aberturalote,
      $$_cacheLocal: (state) => state.cache.cache_localarmazenamento,
      $$_cacheTurno: (state) => state.cache.cache_turno,
      $$_cacheFabrica: (state) => state.cache.cache_fabrica,
    }),

    $$appidaberturalote() {
      return this.formulario.appidaberturalote;
    },

    $$numerobag() {
      return this.formulario.appnumerobag;
    },
    
    // AGRUPA OS LOTES POR SAFRA. DERIVADO DE lotesdaop PARA ACOMPANHAR O CACHE
    // ATUALIZADO PELA SINCRONIZACAO (pushCache) SEM PRECISAR REMONTAR A TELA.
    $$_safraMap() {
      return (this.lotesdaop || []).reduce((map, lote) => {
        const ano = this.$_safraDoLote(lote);
        if (!ano) return map;
        if (!map.has(ano)) map.set(ano, []);
        map.get(ano).push(lote);
        return map;
      }, new Map());
    },

    $$_safrasAutocomplete() {
      const anos = [...this.$$_safraMap.keys()];
      if (this.empresaSafra && !anos.includes(this.empresaSafra)) anos.push(this.empresaSafra);
      return anos.sort((a, b) => a - b);
    },

    // O FILTRO DE SAFRA SÓ EXISTE PARA EMPRESAS COM empsafra PREENCHIDO
    $$_usaSafra() {
      return !!this.empresaSafra;
    },

    $$_lotesSafra() {
      if (!this.$$_usaSafra) return this.lotesdaop || [];
      return this.$$_safraMap.get(this.safra) ?? [];
    }
  },

  watch: {
    'formulario.appnumerobag': function (novo) {
      if (novo === null || novo === undefined || novo === '') return;
      let limpo = String(novo).replace(/[^0-9]/g, '').slice(0, 2);
      limpo = limpo === '' ? null : limpo;
      if (limpo !== novo) {
        this.$nextTick(() => {
          this.formulario.appnumerobag = limpo;
        });
      }
    },

    $$appidaberturalote: {
      handler() {
        setTimeout(() => {
          if (this.formulario.appidaberturalote) {
            this.lotecompleto = null;
            const loteCompleto = (db.aberturalote.where({ ablidaberturalote: this.formulario.appidaberturalote }).toArray());
            loteCompleto.then((item) => {
              this.lotecompleto = item[0];
              db.produto.where({ proidproduto: item[0].ablidproduto }).toArray().then((itemProduto) => {
                if (itemProduto[0]?.proidvariedade) {
                  db.variedade.where({ varidvariedade: itemProduto[0]?.proidvariedade }).toArray().then((itemVariedade) => {
                    this.variedadeCompleta = itemVariedade[0];
                  })
                }
              })
            })
            // const apontamentoExiste = (db.apontamentoproducao.where({ 
            //   appidaberturalote: this.formulario.appidaberturalote,
            //   appnumerobag: Number(this.formulario.appnumerobag)
            // }).toArray());
            // apontamentoExiste.then((item) => {
            //   this.existeapontamento = !!item.length
            // })
          }
        }) 
      }
    },

    $$numerobag: {
      handler() {
        setTimeout(() => {
          if (this.formulario.appidaberturalote) {
            const apontamentoExiste = (db.apontamentoproducao.where({ 
              appidaberturalote: this.formulario.appidaberturalote,
              appnumerobag: Number(this.formulario.appnumerobag)
            }).toArray());
            apontamentoExiste.then((item) => {
              this.existeapontamento = !!item.length
            })
          }
        }) 
      }
    },

    // TROCA DE SAFRA LIMPA O LOTE SELECIONADO, INCLUSIVE QUANDO ELE VEIO DO QR
    // (NESSE CASO TAMBEM DESTRAVA OS CAMPOS DE LOTE E BAG).
    // O PRIMEIRO VALOR (null -> safra inicial) É A MONTAGEM DA TELA, NÃO UMA TROCA.
    safra(_novo, antigo) {
      if (antigo === null || antigo === undefined) return;
      this.lotecompleto = null;
      this.variedadeCompleta = null;
      this.formulario.appidaberturalote = null;
      this.loteviaqr = false;
      sessionStorage.setItem(OPLOCAL_STORAGE.qr, '');
      this.$refs.form?.resetValidation();
    },

    proximolote() {
      sessionStorage.setItem('lote', JSON.stringify(this.proximolote));
    },

    proximoembalagem() {
      sessionStorage.setItem('loteembalagem', JSON.stringify(this.proximoembalagem));
    }
  }

  // watch: {
  //   proximolote(valor) {
  //     this.fabricalocal = (db.aberturalote.where({ fabidfabrica: valor.ablidfabrica  }).toArray())[0];
  //   }
  // }
};
</script>

<style scoped>
  .v-sheet--offset {
    top: 5px;
    position: relative;
  }


  .center {
    width: 100%;
    text-align: center;
  }

  .card {
    padding: 3px;
    margin: 15px 10px 0px 10px
  }

  .card-secador {
    width: 90%;
    text-align: center;
    margin: 20px;
  }

  .linhas {
    height: 21%;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
  }

  .finalizado {
    background-color: #4CAF50;
  }

  .iniciado {
    background-color: #6b93ff;
  }

  .disponivel {
    background-color: #b9b9b9;
  }

  .digitavel {
    margin-bottom: 25px;
  }

  .linha-menor {
    height: 16%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 4px 0px 4px;
    font-size: 13px;
  }

  .inner-card {
    display: flex;
    justify-content: space-between;
    height: 67%;
  }

  .container-inner-items {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .container-inner-items-fill {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .card-btn {
    transform: translateY(10px);
  }

  .txt-center {
    text-align: center;
  }

  .input-container {
      width: 60%;
  }

  .container {
    width: 93vw;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .contaainer {
    width: 93vw;
    max-width: 250px;
    flex-wrap: wrap;
  }

  .textfield {
    width: 90%;
  }

  .n-center >>> input {
      text-align: center;
  }

  .n-center >>> input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .nn-center >>> input {
      text-align: center;
  }

  .nn-center >>> input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .linha-qr {
    display: flex;
  }

  .linha-botoes {
    display: flex;
    width: 100%;
    gap: 8px;
  }

  .botao-acao {
    flex: 1;
    min-width: 0;
  }

  .numero-armazenamento {
    width: 33%;
  }

  .descricaoextra {
    color: #3d68de;
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    padding: 5px;
    background-color: #fdffd2;
  }

  .centerextra {
      flex: 1;
      text-align: center;
      font-size: 14px;
      font-weight: 500;
  }

  /* PADRAO DE CAMPO SOMENTE LEITURA: FUNDO AMARELO */
  .campo-bloqueado >>> .v-input__slot {
    background-color: #fdffd2 !important;
  }

  /* ICONE DE QR DESABILITADO ENQUANTO O LOTE ESTIVER BLOQUEADO */
  .campo-bloqueado >>> .v-input__append-inner {
    opacity: 0.4;
    pointer-events: none;
  }


  
</style>
